import { getFieldValue } from "../core/format";
import { compileFilter, queryLocal, sortItems } from "./local-query";

function createQuery(items) {
  return {
    filter: predicate =>
      createQuery(
        items.filter(typeof predicate === "function" ? predicate : compileFilter(predicate))
      ),
    sortBy: (selector, desc) => createQuery(sortItems(items, [{ selector, desc: !!desc }])),
    select: selector =>
      createQuery(
        items.map(item =>
          typeof selector === "function" ? selector(item) : getFieldValue(item, selector)
        )
      ),
    slice: (skip, take) => createQuery(items.slice(skip, take == null ? undefined : skip + take)),
    count: () => items.length,
    toArray: () => items.slice(),
  };
}

export default function ArrayStore(options = {}) {
  const config = Array.isArray(options) ? { data: options } : options;
  const keyExpr = config.key;

  this._array = config.data || [];
  this.__localStore = true;

  const keyOf = item => (keyExpr ? getFieldValue(item, keyExpr) : item);
  const indexOf = key => this._array.findIndex(item => keyOf(item) === key);

  this.key = () => keyExpr;
  this.keyOf = keyOf;

  this.load = (loadOptions = {}) => {
    const hasOptions =
      loadOptions.filter ||
      loadOptions.sort ||
      loadOptions.group ||
      loadOptions.skip ||
      loadOptions.take;

    if (!hasOptions) return Promise.resolve(this._array.slice());

    return Promise.resolve(queryLocal(this._array, loadOptions).data);
  };

  this.totalCount = (loadOptions = {}) =>
    Promise.resolve(queryLocal(this._array, { filter: loadOptions.filter }).data.length);

  this.byKey = key => Promise.resolve(this._array[indexOf(key)]);

  this.insert = values => {
    this._array.push(values);

    return Promise.resolve(values);
  };

  this.update = (key, values) => {
    const index = indexOf(key);

    if (index >= 0) Object.assign(this._array[index], values);

    return Promise.resolve(key);
  };

  this.remove = key => {
    const index = indexOf(key);

    if (index >= 0) this._array.splice(index, 1);

    return Promise.resolve(key);
  };

  this.clear = () => {
    this._array.splice(0, this._array.length);
  };

  this.createQuery = () => createQuery(this._array);
}
